import { render, staticRenderFns } from "./Code.vue?vue&type=template&id=1e3468fa&scoped=true&"
import script from "./Code.vue?vue&type=script&lang=ts&"
export * from "./Code.vue?vue&type=script&lang=ts&"
import style0 from "./Code.vue?vue&type=style&index=0&id=1e3468fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3468fa",
  null
  
)

export default component.exports